import { useDispatch } from 'react-redux';

import {
  createMetalStreamBankApplicationFunding,
  updateMetalStreamBankApplicationFunding,
} from '../store/actions/metalStream/metalStreamActions';
import useApplicationUid from './useApplicationUid';
import { useMetalStreamData } from './useMetalStreamData';

const useMetalStreamBankApplicationFundingDispatch = () => {
  const dispatch = useDispatch();
  const { MetalStreamData } = useMetalStreamData();
  const { ApplicationUid } = useApplicationUid();

  const metalStreamBankApplicationFundingDispatch = ({
    data,
    onSuccess,
    onError,
  }) => {
    if (MetalStreamData?.BankAccountUid) {
      dispatch(
        updateMetalStreamBankApplicationFunding({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    } else {
      dispatch(
        createMetalStreamBankApplicationFunding({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    }
  };

  return { metalStreamBankApplicationFundingDispatch };
};

export default useMetalStreamBankApplicationFundingDispatch;
